import api from "./api";

const qs = p => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null)
).toString();

const svc = {
  listar:            (p = {}) => api("GET", `/contas-receber?${qs(p)}`),
  buscarPorId:       id       => api("GET", `/contas-receber/${id}`),
  criar:             data     => api("POST", "/contas-receber", data),
  atualizar:         (id, d)  => api("PUT", `/contas-receber/${id}`, d),
  cancelar:          id       => api("PATCH", `/contas-receber/${id}/cancelar`, {}),

  receberParcela:    (id, d)  => api("POST", `/contas-receber/parcelas/${id}/receber`, d),
  estornarRecebimento: (id, d = {}) => api("POST", `/contas-receber/parcelas/${id}/estornar`, d),

  atualizarVencidas: ()       => api("PATCH", "/contas-receber/atualizar-vencidas", {}),
  relatorio:         (p = {}) => api("GET", `/contas-receber/relatorio?${qs(p)}`),
  dashboardOrigens:  (p = {}) => api("GET", `/contas-receber/dashboard-origens?${qs(p)}`),
};

export default svc;
